import { defineMessages } from "react-intl";

const messages = defineMessages({
  addRecipientButtonLabel: {
    id: "email.creation.createModal.addRecipientButtonLabel",
    defaultMessage: "+ Add Email",
    description: "Add recipient button label",
  },
  closeConfirmationNo: {
    id: "email.creation.createModal.closeConfirmationNo",
    defaultMessage: "No",
    description: "Close confirmation no",
  },
  closeConfirmationTitle: {
    id: "email.creation.createModal.closeConfirmationTitle",
    defaultMessage: "Close without sending? <b>Email will not be saved.</b>",
    description: "Close confirmation title",
  },
  closeConfirmationYes: {
    id: "email.creation.createModal.closeConfirmationYes",
    defaultMessage: "Yes",
    description: "Close confirmation yes",
  },
  more: {
    id: "email.creation.createModal.recipients.moreText",
    defaultMessage: "More",
    description: "More text for recipients",
  },
  next: {
    id: "email.creation.createModal.next",
    defaultMessage: "Next",
    description: "Next button in email creation modal",
  },
  nextConfirmationNo: {
    id: "email.creation.createModal.nextConfirmationNo",
    defaultMessage: "Cancel",
    description: "Next confirmation no",
  },
  nextConfirmationTitle: {
    id: "email.creation.createModal.nextConfirmationTitle",
    defaultMessage: "Changes to template were not saved. Send anyways?",
    description: "Next confirmation title",
  },
  nextConfirmationYes: {
    id: "email.creation.createModal.nextConfirmationYes",
    defaultMessage: "Send anyways",
    description: "Next confirmation yes",
  },
  recipientTypeSelectorDisabledBecauseOfAppliedDynamicVariableTooltip: {
    id: "email.creation.createModal.recipientTypeSelector.disabledBecauseOfAppliedDynamicVariableTooltip",
    defaultMessage:
      "This is disabled because you have inserted this type of variable in your email.",
    description: "Recipient type selector disabled because of added dynamic variable tooltip",
  },
  recipientTypeSelectorDisabledBecauseOfAppliedTemplateTooltip: {
    id: "email.creation.createModal.recipientTypeSelector.recipientTypeSelectorDisabledBecauseOfAppliedTemplateTooltip",
    defaultMessage: "This is disabled because you have applied this type of template.",
    description: "Recipient type selector disabled because of applied entity variable tooltip",
  },
  subTitle: {
    id: "email.creation.createModal.subTitle",
    defaultMessage: "{sent}/{total} sends left today",
    description: "Sub Title of email creation modal",
  },
  title: {
    id: "email.creation.createModal.title",
    defaultMessage: "Email",
    description: "Title of email creation modal",
  },
  to: {
    id: "email.creation.createModal.recipients.to",
    defaultMessage: "To",
    description: "To text for recipients",
  },
});

export default messages;
